import Image from 'next/legacy/image'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints } from '@/styles'
import { SectionHeading } from '@/features/Pricing/elements'

import cogirLogo from './images/cogir.png'
import concertLogo from './images/concert.png'
import homelifeLogo from './images/homelife.png'
import joviLogo from './images/jovi.png'
import metcapLogo from './images/metcap.png'
import remaxLogo from './images/remax.png'

const Section = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 0 32px;
  justify-content: space-between;

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px 24px;
  }
`

const ImageWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 100px;
  width: 100%;
  padding: 0 16px;

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    height: 70px;
  }
`

const companies = [
  { img: cogirLogo, alt: 'Cogir Real Estate Logo' },
  { img: remaxLogo, alt: 'Remax Logo' },
  { img: concertLogo, alt: 'Concert Properties Logo' },
  { img: homelifeLogo, alt: 'Homelife Logo' },
  { img: joviLogo, alt: 'Jovi Realty Logo' },
  { img: metcapLogo, alt: 'MetCap Living Logo' }
]

const CompaniesSection = () => {
  const { t } = useTranslation('pricing')

  return (
    <Section>
      <SectionHeading>{t('pricing:Trusted by')}</SectionHeading>
      <Grid>
        {companies.map(company => (
          <ImageWrapper key={company.alt}>
            <Image
              src={company.img}
              alt={company.alt}
              layout="fill"
              objectFit="contain"
            />
          </ImageWrapper>
        ))}
      </Grid>
    </Section>
  )
}

export default CompaniesSection
